/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type ReferralCodeLookup_viewer$ref = any;
export type ReferralCodeLookup_QueryVariables = {
    readonly count?: number | null;
    readonly sortBy?: string | null;
    readonly byReferralCode?: string | null;
};
export type ReferralCodeLookup_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": ReferralCodeLookup_viewer$ref;
    }) | null;
};
export type ReferralCodeLookup_Query = {
    readonly response: ReferralCodeLookup_QueryResponse;
    readonly variables: ReferralCodeLookup_QueryVariables;
};



/*
query ReferralCodeLookup_Query(
  $count: Int
  $sortBy: String
  $byReferralCode: String
) {
  viewer {
    id
    ...ReferralCodeLookup_viewer_1KiJL6
  }
}

fragment ReferralCodeLookup_viewer_1KiJL6 on Viewer {
  user {
    id
    role
    orders(first: $count, byReferralCode: $byReferralCode, sortBy: $sortBy) {
      edges {
        node {
          id
          orderId
          orderNumber
          createDate
          orderTotal
          email
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "count",
            "type": "Int",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "sortBy",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "byReferralCode",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = [
        ({
            "kind": "Variable",
            "name": "byReferralCode",
            "variableName": "byReferralCode",
            "type": "String"
        } as any),
        ({
            "kind": "Variable",
            "name": "first",
            "variableName": "count",
            "type": "Int"
        } as any),
        ({
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy",
            "type": "String"
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ReferralCodeLookup_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "ReferralCodeLookup_viewer",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "byReferralCode",
                                    "variableName": "byReferralCode",
                                    "type": null
                                },
                                {
                                    "kind": "Variable",
                                    "name": "count",
                                    "variableName": "count",
                                    "type": null
                                },
                                {
                                    "kind": "Variable",
                                    "name": "sortBy",
                                    "variableName": "sortBy",
                                    "type": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "ReferralCodeLookup_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "orders",
                                    "storageKey": null,
                                    "args": (v2 /*: any*/),
                                    "concreteType": "OrderConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OrderEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Order",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "orderId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "orderNumber",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "createDate",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "orderTotal",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "email",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "__typename",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "cursor",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "pageInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "endCursor",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "hasNextPage",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedHandle",
                                    "alias": null,
                                    "name": "orders",
                                    "args": (v2 /*: any*/),
                                    "handle": "connection",
                                    "key": "ReferralCodeOrders_orders",
                                    "filters": [
                                        "byReferralCode",
                                        "sortBy"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "ReferralCodeLookup_Query",
            "id": null,
            "text": "query ReferralCodeLookup_Query(\n  $count: Int\n  $sortBy: String\n  $byReferralCode: String\n) {\n  viewer {\n    id\n    ...ReferralCodeLookup_viewer_1KiJL6\n  }\n}\n\nfragment ReferralCodeLookup_viewer_1KiJL6 on Viewer {\n  user {\n    id\n    role\n    orders(first: $count, byReferralCode: $byReferralCode, sortBy: $sortBy) {\n      edges {\n        node {\n          id\n          orderId\n          orderNumber\n          createDate\n          orderTotal\n          email\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'c5629d04ca75c9ea9fd4f2ecb1c19b52';
export default node;
